import React, { Component } from "react";
import "cropperjs/dist/cropper.css";
import error_image from "./assets/images/error-image.png";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught:", error, errorInfo);
    this.sendErrorEmail(
      this.props.token,
      this.props.userEmail,
      error,
      errorInfo,
    );
  }

  sendErrorEmail(token, userEmail, error, errorInfo) {
    const errorDetails = {
      message: JSON.stringify({
        message: error.toString(),
        userEmail: userEmail || "Not signed in",
        stack: errorInfo.componentStack,
        location: window.location.href,
      }),
    };

    const hostname = window.location.hostname;
    // const subdomain_name = hostname.split(".")[0];

    // let newToken = '';
    let baseUrl = "";
    let cleanedToken = token;
    // if(subdomain_name == 'proschool'){
    //    newToken = tokenName.proschool_ai.token;
    //    baseUrl = tokenName.proschool_ai.url;
    // } else if( subdomain_name == 'mycro' ||  subdomain_name == 'localhost'){
    //    newToken = tokenName.proschool_validation.token;
    //    baseUrl = tokenName.proschool_validation.url;
    // } else if( subdomain_name == 'proschool'){
    //    newToken = tokenName.proschool_ai.token;
    //    baseUrl = tokenName.proschool_ai.url;
    // } else {
    //    newToken = tokenName.proschool_validation.token;
    //    baseUrl = tokenName.proschool_validation.url;
    // }

    // if (hostname === "proschool.ai") {
    //    baseUrl = "https://proschool.ai/";
    //    cleanedToken = cleanedToken;
    // } else if (hostname === "qat.proschool.ai") {
    //    baseUrl = "https://qat.proschool.ai/";
    //    cleanedToken = cleanedToken;
    // } else if (hostname === "pre.proschool.ai") {
    //    baseUrl = "https://pre.proschool.ai/";
    //    cleanedToken = cleanedToken;
    // }

    //ameya fix (error while adding bank account)
    if (hostname === "proschool.ai") {
      baseUrl = "https://proschool.ai/";
      cleanedToken = cleanedToken;
    } else if (hostname === "qat.proschool.ai") {
      baseUrl = "https://qat.proschool.ai/";
      cleanedToken = cleanedToken;
    } else if (hostname === "pre.proschool.ai") {
      baseUrl = "https://pre.proschool.ai/";
      cleanedToken = cleanedToken;
    } else if (hostname === "dev.proschool.ai") {
      baseUrl = "https://dev.proschool.ai/";
      cleanedToken = cleanedToken;
    }

    // const cleanedToken = token ? token : newToken;

    //  // If the hostname does not match any of the above, default to proschool.ai
    //  if (!baseUrl) {
    //    baseUrl = "https://proschool.ai/";
    //    cleanedToken = cleanedToken;
    // }

    fetch(`${baseUrl}api/activity/email-logs/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${cleanedToken}`,
      },
      body: JSON.stringify(errorDetails),
    }).catch(console.error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-page-section">
          <div className="error-page-wrapper">
            <div className="error-page-image">
              <img src={error_image} alt="error-page-image" />
            </div>
            <div className="error-page-text">
              <h1>404 : Page Not Found</h1>
              <p>Something went wrong.</p>
              <button
                type="button"
                onClick={() => (window.location.href = "/dashboard/home")}
              >
                Back to Homepage
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
